import { inject } from '@angular/core';
import { AuthService, UserStatus } from './auth.service';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const unloggedGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {

  const auth = inject(AuthService);
  const router = inject(Router);

  const timeout = new Promise((_, reject) => setTimeout(() => reject('Timeout'), 5000));
  
  try {
    await Promise.race([auth.isInitialized, timeout]);
    if ( auth.userStatus === UserStatus.UNLOGGED ) {
      return true;
    }
    return router.createUrlTree(['/']);
  } catch (error) {
    console.error('Error initializing auth service', error);
    return true;
  }

};
